"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgentList = exports.className = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../utils/classFunctions");
const CheckBox_1 = require("../../CheckBox");
const Field_1 = require("../../Form/Field");
const Icon_1 = require("../../Icon");
const LoadingOverlay_1 = require("../../LoadingOverlay");
const Table_1 = require("../../Table");
const messages_1 = require("./messages");
const tableColumns_1 = require("./tableColumns");
const utils_1 = require("./utils");
require("./index.scss");
exports.className = 'agent-list';
class AgentListClass extends react_1.default.PureComponent {
    constructor() {
        var _a, _b, _c, _d, _e, _f;
        super(...arguments);
        this.state = {
            searchText: (_a = this.props.searchText) !== null && _a !== void 0 ? _a : '',
            isActiveOnly: (_b = this.props.isActiveOnly) !== null && _b !== void 0 ? _b : false,
            isAlbania: (_c = this.props.isAlbania) !== null && _c !== void 0 ? _c : false,
            isKosovo: (_d = this.props.isKosovo) !== null && _d !== void 0 ? _d : false,
            isMacedonia: (_e = this.props.isMacedonia) !== null && _e !== void 0 ? _e : false,
            isSwitzerland: (_f = this.props.isSwitzerland) !== null && _f !== void 0 ? _f : false,
        };
        this.submitForm = () => {
            if (!this.props.isSubmitButtonDisable) {
                const { searchText, isActiveOnly, isAlbania, isKosovo, isMacedonia, isSwitzerland, } = this.state;
                this.props.onSubmit({
                    searchText,
                    isActiveOnly,
                    isAlbania,
                    isKosovo,
                    isMacedonia,
                    isSwitzerland,
                });
            }
        };
        this.handleSetSort = (data) => {
            var _a;
            (_a = this.props) === null || _a === void 0 ? void 0 : _a.setSort(data);
        };
        this.handleSubmitForm = (event) => {
            event.preventDefault();
            this.submitForm();
        };
        this.handleSearchTextChange = (event) => {
            this.setState({ searchText: event.target.value }, this.submitForm);
        };
        this.handleIsAlbaniaChange = () => {
            this.setState({ isAlbania: !this.state.isAlbania }, this.submitForm);
        };
        this.handleIsKosovoChange = () => {
            this.setState({ isKosovo: !this.state.isKosovo }, this.submitForm);
        };
        this.handleIsMacedoniaChange = () => {
            this.setState({ isMacedonia: !this.state.isMacedonia }, this.submitForm);
        };
        this.handleIsSwitzerlandChange = () => {
            this.setState({ isSwitzerland: !this.state.isSwitzerland }, this.submitForm);
        };
        this.handleIsOnlyActiveChange = () => {
            this.setState({ isActiveOnly: !this.state.isActiveOnly }, this.submitForm);
        };
    }
    render() {
        const { modificators, isLoading, isDirty, tableColumns, tableData, sortBy, sortOrder, } = this.props;
        const { searchText, isActiveOnly, isAlbania, isKosovo, isMacedonia, isSwitzerland, } = this.state;
        const classNames = (0, classFunctions_1.getClassNames)(exports.className, modificators);
        const loadingOverlayProps = {
            isLoading: isLoading || isDirty,
            hideLoader: !isLoading,
            loadingMessage: isLoading ? undefined : '',
            modificators: 'top',
        };
        return (react_1.default.createElement("div", { className: classNames },
            react_1.default.createElement("form", { className: `${exports.className}__form`, onSubmit: this.handleSubmitForm },
                react_1.default.createElement("div", { className: `${exports.className}__icon` },
                    react_1.default.createElement(Icon_1.Icon, { name: 'search' })),
                react_1.default.createElement("div", { className: `${exports.className}__search` },
                    react_1.default.createElement(Field_1.FormField, { modificators: ['search'], placeholder: this.props.intl.formatMessage(messages_1.messages.searchPlaceholder), onChange: this.handleSearchTextChange, value: searchText })),
                react_1.default.createElement("div", { className: `${exports.className}__buttons` }),
                react_1.default.createElement("div", { className: `${exports.className}__checkboxes` },
                    react_1.default.createElement("div", { className: `${exports.className}__checkboxes-column ${exports.className}__checkboxes-column--active` },
                        react_1.default.createElement(CheckBox_1.CheckBox, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Agent/List:IsActiveOnly', defaultMessage: 'Active only' }), modificators: ['inline'], onChange: this.handleIsOnlyActiveChange, checked: isActiveOnly || false })),
                    react_1.default.createElement("div", { className: `${exports.className}__checkboxes-column` },
                        react_1.default.createElement(CheckBox_1.CheckBox, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Agent/List:Macedonia', defaultMessage: 'Macedonia' }), modificators: ['inline'], checked: isMacedonia, onChange: this.handleIsMacedoniaChange }),
                        react_1.default.createElement(CheckBox_1.CheckBox, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Agent/List:Albania', defaultMessage: 'Albania' }), modificators: ['inline'], checked: isAlbania, onChange: this.handleIsAlbaniaChange })),
                    react_1.default.createElement("div", { className: `${exports.className}__checkboxes-column` },
                        react_1.default.createElement(CheckBox_1.CheckBox, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Agent/List:Switzerland', defaultMessage: 'Switzerland' }), modificators: ['inline'], checked: isSwitzerland, onChange: this.handleIsSwitzerlandChange }),
                        react_1.default.createElement(CheckBox_1.CheckBox, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Agent/List:Kosovo', defaultMessage: 'Kosovo' }), modificators: ['inline'], checked: isKosovo, onChange: this.handleIsKosovoChange })))),
            react_1.default.createElement("div", { className: `${exports.className}__list` },
                react_1.default.createElement(LoadingOverlay_1.LoadingOverlay, { ...loadingOverlayProps },
                    react_1.default.createElement(Table_1.Table, { columns: tableColumns, data: tableData, defaultSortBy: sortBy, defaultSortOrder: sortOrder, manualSortBy: true, setSort: this.handleSetSort, tableModificators: utils_1.tableModificators })))));
    }
}
AgentListClass.defaultProps = {
    children: null,
    loading: false,
    errorMessages: [],
    isSubmitButtonDisable: false,
    onSubmit: () => { },
    tableColumns: tableColumns_1.agentColumns,
    tableData: [],
    sortBy: undefined,
    sortOrder: undefined,
    setSort: () => { },
};
exports.AgentList = (0, react_intl_1.injectIntl)(AgentListClass);
//# sourceMappingURL=index.js.map